export default __webpack_public_path__ + "static/media/dermaexpert.668406ab.jpg";